import { memo } from "react";
import { Col, Container, FormControl, Row } from "react-bootstrap";
import { BzButton, BzChip, BzHeading } from "../../../../components";

const filters = ["Equity", "Debt", "Large Cap", "ELSS", "Growth", "IDCW"];

const TrendingList = ({ mutualFund = [], setIsShowPlaceOrderModal, setFundToBuy, filterToggle, hanldeOnFilter }) => {

    //To open Order by modal
    const handleBuy = (fund) => {

        setIsShowPlaceOrderModal(true);
        setFundToBuy(fund);

    };

    return (
        <>
            <Container fluid className='p-0'>
                <div className='flex-column'>
                    <Row className='g-0 py-4'>
                        <Col className='d-flex justify-content-start align-items-center'>
                            {
                                !filterToggle &&
                                <div onClick={hanldeOnFilter} className='icon-20 icon-searchfilter icon-dark me-4'>&nbsp;</div>
                            }
                            <div className='icon-16 icon-backward-arrow icon-dark me-3'>&nbsp;</div>
                            <BzHeading className='font-medium font-size6 color-text pe-3'>Trending Now</BzHeading>
                            <div className='font-regular font-size6 color-subtext pe-3'>{mutualFund.length} funds found ...</div>
                        </Col>
                        <Col className='d-flex justify-content-end align-items-center'>
                            <BzButton className='btn btn-md btn-outline'>Reset All Filters</BzButton>
                        </Col>
                    </Row>

                    <Row className='g-0 pb-4'>
                        <Col md={10} className='d-flex justify-content-start align-items-center'>
                            <div className='d-flex justify-content-start align-items-center'>
                                <div className='font-regular font-size4 color-text pe-2'>Filters: </div>
                                <div className='filters-chips-wrap'>
                                    {filters.map((element, i) =>
                                        <BzChip key={i} className='filter-chip me-2 text-capitalize'>{element} <div className='icon-10 icon-close icon-dark ms-2'></div></BzChip>
                                    )}
                                </div>
                            </div>
                        </Col>
                        <Col md={2} className='d-flex justify-content-end align-items-center'>
                            <div className='searchbar-wrap mx-auto'>
                                <div className='searchbox'>
                                    <div className='searchicon-wrap'>
                                        <div className='icon-14 icon-grey icon-search'></div>
                                    </div>
                                    <FormControl size='sm' id='watchlist_search' type='search' className='font-regular scripname-searchtext' placeholder='Search Funds' />
                                </div>
                            </div>
                        </Col>
                    </Row>

                    <Row className='g-0 mt-4 mf-explore-funds-trending-scroll'>
                        {mutualFund.map(fund =>
                            <div key={fund.id}>
                                <Row className='g-0 bdr-btm pb-3 mb-3'>
                                    <Col md={4} className='flex-column justify-content-start cursor-pointer pe-5'>
                                        <div className='font-regular font-size4 color-text mb-1'>{fund?.fundName}</div>
                                        <div className='chips-wrap flex-wrap'>
                                            {fund?.category?.map((categoryName, index) => <BzChip key={index} className='chips primary-chip me-2 mb-2'>{categoryName}</BzChip>)}
                                        </div>
                                    </Col>
                                    <Col className='flex-column justify-content-start align-self-center'>
                                        <Row className='g-0'>
                                            <Col className='d-flex justify-content-start align-items-center'>
                                                <div className='font-regular font-size2 color-subtext'>NAV</div>
                                                <div className='icon-14 icon-info icon-dark ms-2'>&nbsp;</div>
                                            </Col>
                                        </Row>
                                        <Row className='g-0'>
                                            <Col>
                                                <div className='font-medium font-size4 color-text'>&#8377;{fund?.nav}</div>
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col className='flex-column justify-content-start align-self-center'>
                                        <div className='font-regular font-size2 color-subtext'>Min. Investment</div>
                                        <div className='font-medium font-size4 color-text'>&#8377;{fund?.minAmount}</div>
                                    </Col>
                                    <Col className='flex-column justify-content-start align-self-center'>
                                        <Row className='g-0'>
                                            <Col>
                                                <div className='font-regular font-size2 color-subtext'>CAGRs</div>
                                            </Col>
                                        </Row>
                                        <Row className='g-0'>
                                            <Col className='d-flex justify-content-start align-items-center'>
                                                <div className='font-medium font-size2 color-text color-positive'>{fund?.cagr}</div>
                                                <div className='font-regular font-size2 color-subtext'>(3Y)</div>
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col md={3} className='d-flex justify-content-end align-items-center'>
                                        <BzButton className='btn btn-outline btn-md'>SIP</BzButton>
                                        <BzButton className='btn btn-positive btn-md ms-3' onClick={() => handleBuy(fund)}>BUY</BzButton>
                                        <div className='icon-24 icon-add-circle icon-dark ms-3'>&nbsp;</div>
                                    </Col>
                                </Row>
                            </div>
                        )}
                    </Row>
                </div>
            </Container>
        </>
    );
};

export default memo(TrendingList);
